import _styled from "@emotion/styled/base";
import { css } from '@emotion/react';
import { typeface, getResetByTag, typography } from './../../../styles';
var defaultStyles = function defaultStyles() {
  return /*#__PURE__*/css("flex:0 1 auto;font-family:", typeface.typefaceBase, ";font-size:", typography.typographyBodyMd, ";user-select:none;white-space:pre-wrap;" + (process.env.NODE_ENV === "production" ? "" : ";label:defaultStyles;"));
};
var resetStyles = getResetByTag('span');
var StyledFormOptionTextLabel = /*#__PURE__*/_styled('span', process.env.NODE_ENV === "production" ? {
  target: "e13phli0"
} : {
  target: "e13phli0",
  label: "StyledFormOptionTextLabel"
})(resetStyles, defaultStyles);
export default StyledFormOptionTextLabel;